import css from 'styled-jsx/css'

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';

  .PhoneBindForm__input {
    display: inline-block;
    width: 60%;
    margin-right: 15px;

    @include respond-to(xs) {
      width: 100%;
      margin-right: 0;
    }
  }

  .PhoneBindForm__button-inner {
    display: inline-block;
    position: relative;
    bottom: 38px;

    @include respond-to(xs) {
      bottom: 0;
    }
  }
`

export default staticStyles
